import type { Game } from "../../data/games";
import { GameArtwork } from "../GameArtwork/GameArtwork";
import styles from "./RecommendedGameCard.module.css";

interface RecommendedGameCardProps {
  game: Game;
  onSelect: (game: Game, trigger: HTMLButtonElement) => void;
}

export function RecommendedGameCard({
  game,
  onSelect,
}: RecommendedGameCardProps) {
  const handleSelect = (event: React.MouseEvent<HTMLButtonElement>) => {
    onSelect(game, event.currentTarget);
  };

  return (
    <button
      className={styles.card}
      type="button"
      aria-label={`Öppna detaljer för ${game.title}`}
      onClick={handleSelect}
    >
      <GameArtwork
        imageUrl={game.imageUrl}
        title={game.title}
        fallbackLabel={game.fallbackLabel}
        categoryId={game.categoryId}
      />
      <span className={styles.copy}>
        <span className={styles.title}>{game.title}</span>
        <span className={styles.category}>{game.category}</span>
      </span>
    </button>
  );
}
